import { render, staticRenderFns } from "./LoadingPlaceReference.vue?vue&type=template&id=77d181fb"
import script from "./LoadingPlaceReference.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports